import { useRef } from 'react';

import CS from './PureModal.module.scss';

export const PureModal = ({
	children,
	// box Control
	boxClass = '',
	boxSize = 'min-w-25 min-h-25',
	boxSpace = 'p-20px',
	//
	onClose = null, // () => {},
	backDropDisabled = null,
	hideCloseIcon = null,
}) => {
	const ref = useRef();

	const closeHandler = (e) => {
		if (!backDropDisabled && ref.current && !ref.current.contains(e.target) && onClose) onClose();
	};

	return (
		<div className={CS.container} onClick={(e) => closeHandler(e)}>
			<div className={`${CS.wrapper}`}>
				<div className={`${CS.content} ${boxClass} ${boxSize} ${boxSpace}`} ref={ref}>
					{children}

					{!hideCloseIcon && onClose && <i className={`${CS.closeIcon} fa fa-close`} onClick={onClose} />}
				</div>
			</div>
		</div>
	);
};
